/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { useRef, useCallback } from "react";

export const useRefWithCallback = (callback?: (element: HTMLElement) => void) => {
    const ref = useRef(null);
    const setRef = useCallback((node) => {
        if (callback && node) {
            callback(node);
        }
        ref.current = node;
        //eslint-disable-next-line
    }, []);
    return setRef;
};
